export default __webpack_public_path__ + "static/media/logo1.d81aef55.png";